import React from 'react';

export const CopyElementIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 11.9997H3.33333V5.33301C3.33333 3.86634 4.53333 2.66634 6 2.66634H11.3333V1.33301H6C3.8 1.33301 2 3.13301 2 5.33301V11.9997ZM6 14.6663H12.6667C13.4 14.6663 14 14.0663 14 13.333V5.33301C14 4.59967 13.4 3.99967 12.6667 3.99967H6C5.26667 3.99967 4.66667 4.59967 4.66667 5.33301V13.333C4.66667 14.0663 5.26667 14.6663 6 14.6663ZM6 5.33301H12.6667V13.333H6V5.33301Z"
        fill="currentColor"
      />
    </svg>
  );
};
